import { format, parseISO } from 'date-fns';
import { nl } from 'date-fns/locale';

export function euro(val) {
  return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(val ?? 0);
}

export function fmtDate(str) {
  if (!str) return '—';
  try { return format(parseISO(str), 'd MMM yyyy', { locale: nl }); }
  catch { return str; }
}
